// @flow
import * as React from 'react';

const RequiredAsterisk = () => <span className="text-black-50 text-primary">*</span>;

export default RequiredAsterisk;
